/* eslint-disable @typescript-eslint/camelcase */
import React, {
  useCallback,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { saasAxios } from '../utils/axios';

import './GeetestRecaptcha.styl';
import geetestFunction from './gt.js';

if(!(window as any).initGeetest){
  geetestFunction(window);
}


function GeetestRecaptcha({ onResolved, onCancel, onLoaded, language }:{
  onResolved: Function;
  onCancel: Function;
  onLoaded: Function;
  language: string;
}, ref: React.Ref<unknown> | undefined) {

  const execute = useRef<any>(() => null);
  const getResponse = useRef<any>(() => null);
  const reset = useRef<any>(() => null);
  const resolved = useRef<any>(() => null);

  const loaded = useCallback(() => {
    const loadFunc = async () => {
      let geetestLocale = 'en';
      const systemLocale = language;
      
      if (systemLocale === 'zh-HK' || systemLocale === 'zh-hk') {
        geetestLocale = 'zh-hk';
      }
      if (systemLocale === 'zh-CN' || systemLocale === 'zh-cn') {
        geetestLocale = 'zh-cn';
      }

      try {
        const response = await saasAxios('/api/user/geetest-init', {});
        if (response.code !== 0) {
          return;
        }

        const result = response.result ?? {};
        (window as any).initGeetest(
          {
            gt: result.gt,
            challenge: result.challenge,
            offline: !result.success,
            new_captcha: true,
            product: 'bind',
            lang: geetestLocale,
          },
          (captchaObj:any) => {
            captchaObj.onReady(() => {
              onLoaded();
              execute.current = () => {
                captchaObj.verify();
              };
            });

            captchaObj.onSuccess(() => {
              const recaptchaResult = captchaObj.getValidate();
              getResponse.current = () => {
                const params = {
                  geetestChallenge: recaptchaResult.geetest_challenge,
                  geetestValidate: recaptchaResult.geetest_validate,
                  geetestSeccode: recaptchaResult.geetest_seccode,
                };
                return params;
              };
              if (resolved.current) {
                resolved.current();
              }
            });

            captchaObj.onClose(() => {
              onCancel();
            });

            reset.current = () => {
              captchaObj.reset();
            };
          },
        );
      } catch (e) {
        // eslint-disable-next-line
        console.log('gitest error: ', e);
        return;
      }
    };
    loadFunc();
  }, [language, onCancel, onLoaded]);

  useEffect(() => {
    resolved.current = onResolved;
  }, [onResolved]);

  useEffect(() => {
    if ((window as any).initGeetest) {
      loaded();
    }
  }, [loaded]);

  

  useImperativeHandle(ref, () => ({
    execute: () => {
      execute.current();
    },
    getResponse: () => getResponse.current(),
    reset: () => {
      reset.current();
    },
  }));

  return <div className="geetest-recaptcha" />;
}

export default forwardRef(GeetestRecaptcha);
